import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';
import modalStore, { ModalOption } from '@client/stores/modalStore';
import { Modal } from './Modal';

const MenuModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    const menuOption = option.menu!;

    const handleItemClick = async (item: (typeof menuOption.items)[0]) => {
        try {
            await item.onSelect({ modalId });

            if (menuOption.closeOnSelect) {
                modalStore.setReturnValue(modalId, undefined);
            }
        } catch (error) {
            console.error('Menu item action failed:', error);
        }
    };

    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <div className="flex flex-col gap-2">
                    {menuOption.items.map((item, index) => (
                        <button
                            key={index}
                            className={twMerge('flex cursor-pointer items-center gap-3 py-2')}
                            onClick={(e) => {
                                e.preventDefault();
                                handleItemClick(item);
                            }}
                        >
                            {item.icon && (
                                <div className="text-base-content shrink-0">{item.icon}</div>
                            )}
                            <div className="grow text-left font-normal">{item.name}</div>
                        </button>
                    ))}
                </div>
            </Modal.BodyScroll>
        </Modal.Dialog>
    );
});

export default MenuModal;
